<template>
  <div class="store-item">
    <div class="card-store">
      <div class="card-store-content">
        <div class="card-block card-store-content__title">
          <div class="wrapp-text">
            <h3 class="title">{{store.name}}</h3>
            <h6 class="subtitle">{{address}}</h6>
          </div>
          <div class="wrapp-distance" v-if="distance">
            <svg class="o-icon"><use xlink:href="#map-pin-2-line"></use></svg>
            <span class="text">{{distance}}</span>
          </div>
        </div>
        <div class="card-block card-store-content__ctas">
          <button class="btn btn-icon" v-b-toggle="'accordion-' + store.code">
            <div class="wrapp-time">
              <svg class="o-icon"><use xlink:href="#clock"></use></svg>
              <span class="text">{{ $t('time') }}</span>
            </div>
          </button>
          <template v-if="!isCheckoutMode">
            <router-link :to="{ name: 'Boutique', params: { store_code: store.code } }"  class="bcm-link t-small">{{ $t('view-detail') }}</router-link>
          </template>
          <template v-else>
            <button class="btn btn-none bcm-link" @click.prevent="selectStoreForPickup">
              <span class="text">{{ $t('pickup.select-this-store') }}</span>
            </button>
          </template>
        </div>
        <div class="card-block card-store-content__working-hours" v-if="store.working_hours">
          <b-collapse :id="'accordion-' + store.code">
            <div class="wh-list" v-for="(wh, index) in store.working_hours" :key="index">
              <span class="label">{{index}} </span>
              <span class="wh">{{wh.  from}} - {{wh.to}}</span>
            </div>
          </b-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/helpers'
import CardStore from 'theme/components/StoreLocator/CardStore'

export default {
  name: 'StoreTile',
  mixins: [CardStore],
  props: {
    store: {
      type: Object,
      required: true
    },
    inputText: {
      type: String,
      default: () => ''
    },
    isCheckoutMode: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    selectStoreForPickup () {
      EventBus.$emit('storePickup:selectStore', this.store)
    }
  }
}
</script>
